import { type FC, useContext, useMemo } from "react";
import UnescapedContent from "../../../../Misc/UnescapedContent";
import { createStyleFromPadding } from "../../../PaddingInput";
import { createBorderStyles } from "../../BorderSettingsDialog";
import { DragDropComponentEmptyContext } from "../../DragDropComponent";
import { type ComponentOptions, DragDropEditorContext } from "../../DragDropTypes";

export const TextComponentEdit: FC<ComponentOptions> = ({
    style: styleProps,
    value,
}) => {
    const { textReplacement } = useContext(DragDropEditorContext);

    const empty = useContext(DragDropComponentEmptyContext);

    const text = useMemo(() => {
        if(typeof value !== "string") {
            return "";
        }

        return textReplacement.parse(value);
    }, [ value, textReplacement ]);

    if(!text) {
        return empty;
    }

    const {
        padding,
        border,
        fontSize,
        ...styleRest
    } = styleProps;

    const style = {
        width   : "100%",
        ...styleRest,
        fontSize: typeof fontSize === "undefined" ? fontSize : `${fontSize}px`,
        ...(typeof padding !== "undefined" ? createStyleFromPadding(padding) : {}),
        ...(typeof border !== "undefined" ? createBorderStyles(border) : {}),
        overflow: "hidden",
    };

    return (
        <UnescapedContent style={style}>
            {text}
        </UnescapedContent>
    );
};
